<template>
  <div>
    <div class="ethi-row">
      <v-text-field
        v-if="editing"
        v-model="editingHeaderText"
        autofocus
        @keyup.enter="saveChanges"
        @keyup.escape="revertChanges"
      />
      <h2 v-else :class="textColourClass">{{ value.title }}</h2>
      <div v-if="editing" class="ethi-actions">
        <icon-button
          class="small-button"
          size="x-small"
          icon="check"
          color="success"
          icon-color="white"
          @click="saveChanges"
        />
        <icon-button
          v-if="editing"
          class="small-button"
          size="x-small"
          icon="clear"
          color="error"
          icon-color="white"
          @click="revertChanges"
        />
      </div>
      <div v-else class="ethi-actions">
        <extraction-template-item-actions
          :item-style="itemStyle"
          is-header-item
          show-edit-icon
          @delete="deleteHeader"
          @edit="editHeader"
          @revert="revertHeader"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { DataExtractionFieldHeader } from '@/models';
import IconButton from '@/components/Common/IconButton.vue';
import ExtractionTemplateItemActions from './ExtractionTemplateItemActions.vue';
import { ExtractionTemplateItemStyle } from '@/enums';

export default {
  name: 'ExtractionTemplateHeaderItem',
  components: {
    IconButton,
    ExtractionTemplateItemActions,
  },
  props: {
    value: {
      type: DataExtractionFieldHeader,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    itemStyle: {
      type: String,
      default: ExtractionTemplateItemStyle.DEFAULT,
      validator: (val) =>
        Object.values(ExtractionTemplateItemStyle).includes(val),
    },
  },
  emits: ['input', 'delete-field', 'revert-field'],
  data: () => ({
    editing: false,
    editingHeaderText: null,
  }),
  computed: {
    textColourClass() {
      switch (this.itemStyle) {
        case ExtractionTemplateItemStyle.NEW:
          return 'primary--text';
        case ExtractionTemplateItemStyle.MODIFIED:
          return 'success--text';
        case ExtractionTemplateItemStyle.DELETED:
          return 'error--text';
        default:
          return null;
      }
    },
  },
  watch: {
    isActive: {
      immediate: true,
      handler(active) {
        if (active) {
          this.editing = true;
        }
      },
    },
  },
  methods: {
    editHeader() {
      this.editingHeaderText = this.value.title;
      this.editing = true;
    },
    revertHeader() {
      this.$emit('revert-field', this.value.id);
    },
    deleteHeader() {
      this.$emit('delete-field', this.value.id);
    },
    saveChanges() {
      if (this.editingHeaderText !== this.value.title) {
        const newField = new DataExtractionFieldHeader({
          ...this.value,
          title: this.editingHeaderText,
        });
        this.$emit('input', newField);
      }
      this.editing = false;
      this.editingHeaderText = null;
    },
    revertChanges() {
      this.editing = false;
      this.editingHeaderText = null;
      if (!this.value.title) {
        this.$emit('delete-field', this.value.id);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ethi-row {
  display: grid;
  grid: 'header actions' / 1fr auto;
  grid-gap: 1rem;
  align-items: center;
  width: 500px;
  min-height: 70px;
}

.ethi-actions {
  display: flex;
  gap: 1.5rem;
}

.small-button {
  width: 24px;
  height: 24px;
}
</style>
